angular.module("questionarioAdv.module").component("firmatari", {
  templateUrl: "ng/components/questionarioAdv/firmatari/firmatari.html",
  bindings: {
    model: "=",
    newTitolariAdd: "&",
    exportValidationComponent: "&",
    domini: "<",
    formGiurCli: "<",
    resetSupportModel: "<",
    startQuestionario: "<",
    isPagoDopo: "<",
    clienteIsAzienda: "<",
    clienteIsCoc: "<",
    checkFiduciariaSelected: "<",
    listaNazioni: "<",
    submitError: "<",
    externalLink: "<",
    readOnly: "<",
    isPostVendita: '<',
    ndgCli: '<'
  },
  controller: Firmatari,
  controllerAs: "firmatariCtrl",
});

function Firmatari() {
  var self = this;

  self.$onInit = function () {
    self.validatingComponent()
  };

  self.validatingComponent = function () {
    var testComponentValid = true;
	
	if (self.model && self.model.length && self.model.length > 0) {
		var tempFirmArray =
		  self.model.filter((firm) => {
		    return !firm.annullato && !firm.annullatoFe && !firm.hide;
		  });
		if (tempFirmArray.length) {
		    testComponentValid = tempFirmArray.every((x) => {
		    return x.isOk == true;
		  });
		}
	}
	else {
		testComponentValid = false;
	}

    console.log("Il form firmatari è:", testComponentValid);
    self.exportValidationComponent({
      valid: testComponentValid
    })
  }
}
